import { render } from "./CustomerView.vue?vue&type=template&id=f2b569f4&scoped=true"
import script from "./CustomerView.vue?vue&type=script&lang=js"
export * from "./CustomerView.vue?vue&type=script&lang=js"

import "./CustomerView.vue?vue&type=style&index=0&id=f2b569f4&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2b569f4"]])

export default __exports__